import { Injectable } from '@angular/core';
import { ContextService, XenaClient } from 'src/app/services';
import { ICostType } from 'src/app/xena-api/dtos';
import { IQueryStringFilter } from 'src/app/xena-api/filters';
import { BaseService } from 'src/app/xena-api/controllers/base';


@Injectable({
  providedIn: 'root'
})
export class CostTypeService extends BaseService<ICostType, IQueryStringFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'CostType');
  }
}
